export default {
      id: "reports_trips-usage",
      viewBox: "0 0 44 47",
      url: __webpack_public_path__ + "img/icons.svg#reports_trips",
      toString: function () {
        return this.url;
      }
    }